import { useLocales } from '@shared/locales'
import { Tag } from 'antd'

import type { GeneratorKey } from '@crm/api'

type Props = {
  generatorKey?: GeneratorKey
}

// The API identifies a generator by its raw key (`casco_cross_sell`). The label
// falls back to that key so a generator added server-side still reads sanely
// before its translation lands.
export const GeneratorTag = ({ generatorKey }: Props) => {
  const { t } = useLocales()

  if (!generatorKey) {
    return null
  }

  return <Tag>{t(`lead_generation.${generatorKey}`, generatorKey)}</Tag>
}
